import { createTheme, Theme, ThemeOptions } from '@mui/material/styles';

// Base theme with common settings
const baseTheme: ThemeOptions = {
  typography: {
    fontFamily: 'Montserrat, sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
    },
    h2: {
      fontWeight: 600,
      fontSize: '2rem',
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.5rem',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.25rem',
    },
    body1: {
      fontSize: '1rem',
      fontWeight: 500,
    },
    button: {
      textTransform: 'none' as const,
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '25px',
          padding: '8px 24px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '25px',
        },
      },
    },
  },
};

// Course learning theme (original theme)
export const courseTheme: Theme = createTheme({
  ...baseTheme,
  palette: {
    mode: 'dark',
    primary: {
      main: '#4B4EFC',
      light: '#6D70FF',
      dark: '#3538FC',
    },
    secondary: {
      main: '#43FE8C',
      light: '#65FFA1',
      dark: '#21FC74',
    },
    background: {
      default: '#232323',
      paper: 'rgba(38, 38, 38, 0.6)',
    },
    text: {
      primary: '#FFFFFF',
      secondary: 'rgba(255, 255, 255, 0.7)',
    },
  },
  components: {
    ...baseTheme.components,
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#000000',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(38, 38, 38, 0.6)',
          borderRadius: '25px',
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#000000',
          minHeight: '100vh',
        },
      },
    },
  },
});

// Home page black theme
export const homeTheme: Theme = createTheme({
  ...baseTheme,
  palette: {
    mode: 'dark',
    primary: {
      main: '#4B4EFC',
      light: '#6D70FF',
      dark: '#3538FC',
    },
    secondary: {
      main: '#43FE8C',
      light: '#65FFA1',
      dark: '#21FC74',
    },
    background: {
      default: '#000000',
      paper: 'rgba(20, 20, 20, 0.8)',
    },
    text: {
      primary: '#FFFFFF',
      secondary: 'rgba(255, 255, 255, 0.7)',
    },
  },
  components: {
    ...baseTheme.components,
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#000000',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(20, 20, 20, 0.8)',
          borderRadius: '25px',
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#000000',
          minHeight: '100vh',
        },
      },
    },
  },
});

// For backward compatibility, export the original theme as default
export const theme: Theme = courseTheme;